 
  const Swipes = new Swiper('.pdp_swiper', {
    loop: true,
    effect: 'fade',  
    fadeEffect: {
      crossFade: true 
      ,duration: 1500
    },
    navigation: {
        nextEl: '.swiper-button-next-full-continer',
        prevEl: '.swiper-button-prev-full-contaner',
    },
    pagination: {
        el: '.swiper-pagination-full-containr',
    },
});
window.myslider=Swipes;  
const setAriaSelected = (selectedIndex) => {
  const paginationBullets = document.querySelectorAll('.swiper-pagination-bullet');
  paginationBullets.forEach((bullet, index) => {
    if(index === selectedIndex){
      bullet.setAttribute("aria-selected", "true");
      bullet.setAttribute("tabindex", 0);
    }else{
      bullet.setAttribute("aria-selected", "false");
      bullet.setAttribute("tabindex", -1);
    }
  });
}
const paginationBulletContainer = document.querySelectorAll('.swiper-pagination-bullets');
paginationBulletContainer.forEach(container => {
  container.role = 'listbox';
  container.ariaLabel = "Slide navigation selector";
})
const paginationBullets = document.querySelectorAll('.swiper-pagination-bullet');
paginationBullets.forEach((bullet, index) => {
  bullet.role = 'option';
  bullet.addEventListener('click', () => { 
    Swipes.slideTo(index);
  });
});
const prevButton = document.querySelector('.swiper-button-prev-full-container');
const nextButton = document.querySelector('.swiper-button-next-full-container');

prevButton.addEventListener('click', function () {
  window.myslider.slidePrev();
});

nextButton.addEventListener('click', function () {
  window.myslider.slideNext();
});

setInterval(() => {
  if(window.myslider.realIndex !== undefined){
    setAriaSelected(window.myslider.realIndex);
  }
}, 1000);
